import SchoolView from "./SchoolView"

export default  SchoolView;
